import { NgModule } from "@angular/core";
import { TechnicalLettersComponent } from "./technical-letters.component";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { ManageIssuersComponent } from "./manage-issuers/manage-issuers.component";
import { SharedModule } from "../shared.module";
import { AddLetterComponent } from "./add-letter/add-letter.component";
import { InputDialogComponent } from "./input-dialog/input-dialog.component";
import { PlantAdminsComponent } from "./plant-admins/plant-admins.component";
import { DeletedLetterLogsComponent } from "./deleted-letter-logs/deleted-letter-logs.component";
import { EditTechnicalLettersComponent } from "./edit-technical-letters/edit-technical-letters.component";
import { CommonModule } from "@angular/common";
import { AddEquipmentComponent } from "./add-equipment/add-equipment.component";
import { DeletedEquipmentLogComponent } from "./deleted-equipment-log/deleted-equipment-log.component";
import { HistoryLogComponent } from "./history-log/history-log.component";
import { LetterLogComponent } from "./letter-log/letter-log.component";
import { BulkEditComponent } from "./bulk-edit/bulk-edit.component";


const componentList = [
  TechnicalLettersComponent,
  ManageIssuersComponent,
  AddLetterComponent,
  InputDialogComponent,
  PlantAdminsComponent,
  DeletedLetterLogsComponent,
  EditTechnicalLettersComponent,
  AddEquipmentComponent,
  HistoryLogComponent,
  LetterLogComponent,
  DeletedEquipmentLogComponent,
  BulkEditComponent
];


@NgModule({
  declarations: componentList,
    imports: [SharedImportsModule, SharedModule, CommonModule],
})
export class TechnicalLettersModule {}
